import { render, staticRenderFns } from "./Contractors.vue?vue&type=template&id=58e6e83b&scoped=true"
import script from "./Contractors.vue?vue&type=script&lang=js"
export * from "./Contractors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6e83b",
  null
  
)

export default component.exports